import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={46}
            height={47}
            viewBox="0 0 46 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        {...props}
        >
        <rect x={0.5} y={0.898438} width={45} height={45} rx={22.5} fill="#fff" />
        <rect
            x={0.5}
            y={0.898438}
            width={45}
            height={45}
            rx={22.5}
            stroke={theme["#0EA59D"]}
        />
        <path
            d="M31.333 31.105a.63.63 0 01-.625.625H15.29a.63.63 0 01-.625-.625.63.63 0 01.625-.625h15.417a.63.63 0 01.625.625zM25.826 17.166l-8.95 8.95a.86.86 0 01-1.226 0h-.008a2.983 2.983 0 010-4.208l5.959-5.959a2.978 2.978 0 014.216 0 .858.858 0 01.009 1.217z"
            fill={theme["#0D968F"]}
        />
        <path
            d="M30.35 20.474l-2.542-2.542a.86.86 0 00-1.225 0l-8.95 8.95a.86.86 0 000 1.225l2.542 2.55a2.992 2.992 0 004.216 0l5.95-5.958a2.965 2.965 0 00.009-4.225zm-6.717 7.525l-1.008 1.016a.548.548 0 01-.767 0 .548.548 0 010-.766l1.017-1.017c.2-.2.55-.2.758 0a.548.548 0 010 .767zm3.309-3.309l-2.034 2.042c-.208.2-.55.2-.767 0a.548.548 0 010-.767l2.042-2.041c.2-.2.55-.2.759 0a.548.548 0 010 .766z"
            fill={theme["#0D968F"]}
        />
        </svg>
    )
}
  
  export default SvgComponent